import {
  createScriptGameRoomPlayer,
  readMateSpritePage,
  readScriptGameRoom,
  readScriptGameRoomPage,
  trialScriptGameRoom,
} from "@/apis/script-game";
import i18n from "@/locales";
import { MateSprite, ScriptGameRoom } from "@/types/game";
import { defineStore } from "pinia";
import { showConfirmDialog, showLoadingToast, showSuccessToast } from "vant";
import { useGlobalModal } from "./globalModal";
import { useGlobalUser } from "./globalUser";
import { useUI } from "./ui";
export const useDungeon = defineStore("dungeon", {
  state: () => ({
    dungeonList: [] as ScriptGameRoom[],
    mateSpriteList: [] as MateSprite[],
    dungeonRoom: {} as ScriptGameRoom,
    myDungeonList: [] as ScriptGameRoom[],
    mateIdSpriteListMap: {} as Record<number, MateSprite[]>,
    mateIdSpriteMap: {} as Record<number, MateSprite>,

    activeRoom: {} as ScriptGameRoom,

    type: "trial",
    selectedMateId: 0,
    selectedMateUuid: "",
    showSelectSpritePopup: false,
    selectedSpriteId: 0,
    desktopSpriteList: [] as MateSprite[],
  }),
  getters: {
    // discoverCurrentList(state) {
    //   return state.discoverList[state.activeTab];
    // },
  },
  actions: {
    async fetchMyDungeonList() {
      const userStore = useGlobalUser();
      const res = await readScriptGameRoomPage(userStore.user.id);
      this.myDungeonList = res.page.data;
    },
    async fetchDungeonList() {
      const res = await readScriptGameRoomPage();
      this.dungeonList = res.page.data;
    },
    async fetchDesktopSpriteList() {
      const res = await readMateSpritePage({
        filter: {
          isOnScreen: 1,
        },
        sort: {
          field: "dtUpdate",
          order: "desc",
        },
        pagination: { page: 1, perPage: 40 },
      });
      this.desktopSpriteList = res.page.data;
    },
    async fetchMateSpriteList(
      mateId: number,
      force = false
    ): Promise<MateSprite[]> {
      if (
        this.mateIdSpriteListMap[mateId] &&
        this.mateIdSpriteListMap[mateId].length &&
        !force
      )
        return this.mateIdSpriteListMap[mateId];
      const res = await readMateSpritePage({
        filter: {
          mateId,
        },
        pagination: { page: 1, perPage: 999 },
        sort: {
          field: "dtUpdate",
          order: "desc",
        },
      });
      this.mateIdSpriteListMap[mateId] = res.page.data;
      res.page.data.forEach((sprite: MateSprite) => {
        this.mateIdSpriteMap[sprite.id!] = sprite;
      });
      return res.page.data;
    },
    async fetchDungeonRoom(uuid: string) {
      const res = await readScriptGameRoom(uuid);
      this.dungeonRoom = res.item;
    },

    showSelectMate(room: ScriptGameRoom, type: "enroll" | "trial") {
      this.activeRoom = room;
      this.type = type;
      useUI().popMateSelector({
        mateOnly: true,
        switchMate: false,
        callback: (mate) => {
          this.selectedMateId = mate.id;
          this.selectedMateUuid = mate.uuid;
          this.showSelectSpritePopup = true;
        },
      });
      // const mateStore = useMate();
      // this.selectedMateId = mateStore.currentMate!.id!;
      // this.selectedMateUuid = mateStore.currentMate!.uuid;
      // this.showSelectSpritePopup = true;
    },

    async onSelectSprite(sprite: MateSprite) {
      try {
        await showConfirmDialog({
          title: i18n.global.t("Dungeons.sprite.confirmSprite", {
            name: sprite.name,
          }),
          confirmButtonText: i18n.global.t("Buttons.confirm"),
          cancelButtonText: i18n.global.t("Buttons.cancel"),
        });
      } catch (e) {
        return;
      }
      this.selectedSpriteId = sprite.id!;
      this.showSelectSpritePopup = false;

      let loading = showLoadingToast(i18n.global.t("Dungeons.detail.join"));

      try {
        if (this.type === "enroll") {
          await createScriptGameRoomPlayer({
            roomId: this.activeRoom.id!,
            mateId: this.selectedMateId,
            mateSpriteId: this.selectedSpriteId,
          });
          loading.close();
          showSuccessToast(i18n.global.t("Dungeons.detail.enrollSuccess"));
        } else {
          loading = showLoadingToast(
            i18n.global.t("Dungeons.detail.createTrial")
          );
          const res = await trialScriptGameRoom(this.activeRoom.id!, {
            mateSpriteId: this.selectedSpriteId,
            mateId: this.selectedMateId,
          });
          this.openDungeon(res.item.serverRoomId);
          loading.close();
        }
      } catch (e) {
        loading.close();
      }

      this.fetchDungeonRoom(this.activeRoom.uuid!);
      this.fetchDungeonList();
    },

    openDungeon(serverRoomId: string) {
      if (location.href.includes("localhost")) {
        window.open(
          `https://test-game-cdn.renwudingdong.com/school-days?room_id=${serverRoomId}`,
          "_blank"
        );
      } else {
        useGlobalModal().openMiniProgramModal(
          `https://test-game-cdn.renwudingdong.com/school-days?room_id=${serverRoomId}`
        );
      }
    },
  },
});
